import React from 'react'
import { render } from 'react-dom'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import HighchartsMore from 'highcharts/highcharts-more';
import apiService from 'apiService';
import { setAgeObjDate } from 'helper/helper';
import { BMICount } from 'view/form/rumus';

HighchartsMore(Highcharts);
const numbers = arr => arr.map(Number);
export default class ImtU extends React.PureComponent {
  constructor(props) {
    super(props);
    // this.afterChartCreated = this.afterChartCreated.bind(this);
    this.state = {
      datas: [],
      chartOptions: {
        title: {
          text: 'IMT Menurut Umur'
        },

        xAxis: {
          // type: 'datetime',
          // accessibility: {
          //     rangeDescription: 'Range: Jul 1st 2009 to Jul 31st 2009.'
          // },
          title: {
            text: 'Umur (bulan)'
          },
        },

        yAxis: {
          title: {
            text: 'IMT'
          }
        },

        tooltip: {
          // crosshairs: true,
          shared: true,
          valueSuffix: ''
        },

        series: []
      }
    };
  }
  getParam = async () => {
    let res = await apiService.get('/management/line_graph?type=imt&sex=' + this.props.patient.patients.sex)
    if (res.code == 200) {
      let orange_top = [];
      res.data.orange_top.map(d => {
        orange_top.push(numbers(d))
      })
      let orange_bottom = [];
      res.data.orange_bottom.map(d => {
        orange_bottom.push(numbers(d))
      })
      let green_top = [];
      res.data.green_top.map(d => {
        green_top.push(numbers(d))
      })
      let green_bottom = [];
      res.data.green_bottom.map(d => {
        green_bottom.push(numbers(d))
      })
      let green = [];
      res.data.green.map(d => {
        green.push(numbers(d))
      })

      this.setState(
        (prevState) => ({
          chartOptions: {
            // object that we want to update
            ...prevState.chartOptions, // keep all other key-value pairs
            series: [{
              name: 'Perkembangan Menurut IMT / U',
              data: this.state.datas,
              zIndex: 1,
              marker: {
                fillColor: 'white',
                lineWidth: 2,
                lineColor: Highcharts.getOptions().colors[0]
              }
            }, {
              name: 'Gizi lebih',
              data: orange_top,
              type: 'arearange',
              lineWidth: 1,
              linkedTo: ':previous',
              color: Highcharts.getOptions().colors[8],
              fillOpacity: 0.3,
              zIndex: 0,
              marker: {
                enabled: false
              }

            }, {
              name: 'Berisiko gizi lebih',
              data: green_top,
              type: 'arearange',
              lineWidth: 1,
              linkedTo: ':previous',
              color: Highcharts.getOptions().colors[3],
              fillOpacity: 0.5,
              zIndex: 0,
              marker: {
                enabled: false
              }
            },
            {
              name: 'Gizi baik',
              data: green,
              type: 'arearange',
              lineWidth: 0,
              linkedTo: ':previous',
              color: Highcharts.getOptions().colors[2],
              fillOpacity: 0.5,
              zIndex: 0,
              marker: {
                enabled: false
              }
            },
            {
              name: 'Gizi baik',
              data: green_bottom,
              type: 'arearange',
              lineWidth: 1,
              linkedTo: ':previous',
              color: Highcharts.getOptions().colors[2],
              fillOpacity: 1,
              zIndex: 0,
              marker: {
                enabled: false
              }
            }, {
              name: 'Gizi kurang',
              data: orange_bottom,
              type: 'arearange',
              lineWidth: 0,
              linkedTo: ':previous',
              color: Highcharts.getOptions().colors[3],
              fillOpacity: 0.3,
              zIndex: 0,
              marker: {
                enabled: false
              }

            },
            ], // update the value of specific key
          },
        })
      );
    }
  }
  uniqBy(a, key) {
    var seen = {};
    return a.filter(function (item) {
      var k = key(item);
      return seen.hasOwnProperty(k) ? false : (seen[k] = true);
    })
  }
  componentDidUpdate(prevProps) {
    if (this.props.histories.length !== prevProps.histories.length) {
      let data = [];
      this.props.histories.map(a => {

        data.push([setAgeObjDate(this.props.patient.patients.birth_date, a.created_at).m + setAgeObjDate(this.props.patient.patients.birth_date, a.created_at).y * 12, BMICount(parseInt(a.examinations[0]?.weight), parseInt(a.examinations[0]?.height))])
      })
      let clearData = this.uniqBy(data, JSON.stringify);
      this.setState({ datas: clearData }, () => this.getParam())
      console.log(clearData)
    }
  }
  componentDidMount() {
    if (this.props.histories.length > 0) {
      let data = [];
      this.props.histories.map(a => {

        data.push([setAgeObjDate(this.props.patient.patients.birth_date, a.created_at).m + setAgeObjDate(this.props.patient.patients.birth_date, a.created_at).y * 12, BMICount(parseInt(a.examinations[0]?.weight), parseInt(a.examinations[0]?.height))])
      })
      let clearData = this.uniqBy(data, JSON.stringify);
      this.setState({ datas: clearData }, () => this.getParam())
    }
  }
  render() {
    return (
      <div>
        <HighchartsReact
          highcharts={Highcharts}
          options={this.state.chartOptions}
        //   callback={this.afterChartCreated}
        />
      </div>
    );
  }
}

